import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

// actions
import { getOrganizations, statusType } from '../../../actions'

// components
import { Banner, Spinner } from '../../../components'
import OrganizationToolbar from './toolbar/toolbar.component'
import OrganizationGrid from './grid/grid.component'

import { getPageSize, THEMES } from '../../../utils'

/**
 * Contact landing Page
 */
class CustomContactLandingPage extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      filters: {
        query: '',
        limit: getPageSize('organization-grid') || 10,
        page: 1
      }
    }

    this.handleFilterChange = this.handleFilterChange.bind(this)
  }

  /**
   * Component Did Mount
   */
  componentDidMount () {
    this.getOrganizations()
  }

  /**
   * Get Organizations that have Custom Contacts
   */
  getOrganizations () {
    const { getOrganizations } = this.props
    const { filters } = this.state
    getOrganizations(filters)
  }

  /**
   * Handle page and query change
   * @param filters
   */
  handleFilterChange (filters) {
    this.setState(
      { filters: { ...this.state.filters, ...filters } },
      () => this.getOrganizations()
    )
  }

  /**
   * Render
   * @returns {*}
   */
  render () {
    const { history, organizations: { data, initialLoading, status, total } } = this.props
    const { filters } = this.state

    return (
      <>
        <Banner
          title='Custom Contacts'
          icon='q4i-custom-2pt' />
        <div className='page_grid'>
          {(status === statusType.IN_PROGRESS) && <Spinner mask theme={THEMES.RAIN} />}
          <OrganizationToolbar
            handleFilterChange={this.handleFilterChange} />
          <OrganizationGrid
            isGridReady={!initialLoading}
            history={history}
            data={data}
            filters={filters}
            total={total}
            handleFilterChange={this.handleFilterChange} />
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    organizations: state.custom.organizations
  }
}

const mapDispatchToProps = (dispatch) => ({
  getOrganizations: bindActionCreators(getOrganizations, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomContactLandingPage)